// import { useState, useRef } from "react";

// function MealSelectionButton({
//   text,
//   icon = null,
//   options = [],
//   onSelect = null,
//   date,
//   disabled,
//   mealId,
//   bgColor = "#295B24",
//   textColor = "#fff",
//   iconPosition = "Right",
//   className = "",
// }) {
//   const [selectedValue, setSelectedValue] = useState("");
//   const selectRef = useRef(null); // ✅ ref for the select element

//   const handleSelectChange = (e) => {
//     const selectedId = e.target.value;
//     setSelectedValue(selectedId);
//     if (onSelect) onSelect(date, mealId, selectedId);
//   };

//   const handleIconClick = () => {
//     if (selectRef.current && !disabled) {
//       selectRef.current.focus(); // ✅ focus the select
//       selectRef.current.click(); // optional: try to open dropdown in some browsers
//     }
//   };

//   return (
//     <div
//       className={`flex items-center rounded-md font-mono relative transition px-2 ${className}`}
//       //style={{ backgroundColor: options.length > 0 ? bgColor : "#ccc", color: textColor }}
//     >
//       {options.length === 0 ? (
//         <span className="text-sm opacity-80 select-none px-2 py-1 text-black">
//           Unavailable
//         </span>
//       ) : (
//         <>
//         <div className="rounded-md flex items-center px-2" style={{ backgroundColor: options.length > 0 ? bgColor : "#ccc"}}>

//           <select
//             ref={selectRef} // ✅ attach ref
//             value={selectedValue}
//             onChange={handleSelectChange}
//             title="Click to select meal"
//             className={`${
//               disabled ? "pointer-events-none  max-w-[95px]" : "w-[55px] max-w-[100px]"
//             }  rounded-md decorated appearance-none cursor-pointer text-center text-white hover:text-black transition-all duration-200  focus:max-w-[200px]`}
//             style={{
//               color: selectedValue ? textColor : "#fff",
//               backgroundColor: bgColor,
//             }}
//           >
//             <option value="" disabled hidden>
//               {text}
//             </option>
//             {options.map((opt, index) => (
//               <option key={opt._id || opt.id || index} value={opt._id || opt.id} className="text-white decorated">
//                 {opt.title}
//               </option>
//             ))}
//           </select>

//           {/* Icon */}
//           {!disabled && icon && iconPosition === "Right" && (
//             <span className="flex items-center cursor-pointer  text-white" onClick={handleIconClick}>
//               {icon}
//             </span>
//           )}
//            </div>
//         </>
//       )}
//     </div>
//   );
// }

// export default MealSelectionButton;

import { useState, useRef, useEffect, useId } from "react";
import Modal from "./Modal";
import { FaBowlRice } from "react-icons/fa6";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { motion } from "framer-motion";
import { cleanHTML } from "../../components/utils/commonHelper";
function MealSelectionButton({
  text,
  options = [],
  onSelect,
  icon,
  date,
  mealId,
  iconPosition = "Right",
  disabled,
  bgColor = "#295B24",
  textColor = "#fff",
  className = "",
}) {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [showOnLeft, setShowOnLeft] = useState(false);
  const [showFood, setShowFood] = useState(false);
  const [showingFoodItem, setShowingFoodItem] = useState(null);
  const [activeIndexMap, setActiveIndexMap] = useState({});
  const dropdownRef = useRef(null);
  const instanceId = useId(); // ✅ unique per component

  const handleSelect = (item) => {
    setSelected(item);
    setOpen(false);
    setHoveredItem(null);
    onSelect?.(date, mealId, item._id);
  };

  const toggleOpen = () => {
    if (!open) {
      // 🔔 Tell others to close
      window.dispatchEvent(
        new CustomEvent("meal-dropdown-open", {
          detail: instanceId,
        })
      );
    }
    setOpen((prev) => !prev);
  };

  /** Close if another dropdown opens */
  useEffect(() => {
    const handleGlobalOpen = (e) => {
      if (e.detail !== instanceId) {
        setOpen(false);
        setHoveredItem(null);
      }
    };

    window.addEventListener("meal-dropdown-open", handleGlobalOpen);
    return () =>
      window.removeEventListener("meal-dropdown-open", handleGlobalOpen);
  }, [instanceId]);

  /** Detect available space for hover card */
  const updateHoverPosition = () => {
    if (!dropdownRef.current) return;

    const rect = dropdownRef.current.getBoundingClientRect();
    const hoverWidth = 520;

    const spaceRight = window.innerWidth - rect.right;
    const spaceLeft = rect.left;

    setShowOnLeft(spaceRight < hoverWidth && spaceLeft > hoverWidth);
  };

  useEffect(() => {
    if (open) {
      updateHoverPosition();
      window.addEventListener("resize", updateHoverPosition);
    }
    return () => {
      window.removeEventListener("resize", updateHoverPosition);
    };
  }, [open]);

  return (
    <>
      <div className={`relative ${className}`} ref={dropdownRef}>
        {options.length === 0 ? (
          <span className="text-sm opacity-80 font-mono select-none px-2 py-1 text-black">
            Unavailable
          </span>
        ) : (
          <button
            disabled={disabled}
            onClick={toggleOpen}
            className="flex items-center justify-between gap-2 px-3 py-0 rounded-md w-full text-left"
            style={{ backgroundColor: bgColor, color: textColor }}
          >
            <span className="truncate font-mono text-[18px]">
              {selected ? selected.title : text}
            </span>

            {!disabled &&
              icon &&
              iconPosition === "Right" &&
              text === "select" && (
                <span className="text-[20px] font-bold leading-none select-none">
                  {icon}
                </span>
              )}
          </button>
        )}

        {open && (
          <div
            className={`absolute z-50 mt-2 w-60 bg-green rounded-md shadow-lg ${
              showOnLeft ? "right-0" : "xs:right-[50%] xs:translate-x-[50%]"
            }`}
          >
            <div className="relative">
              {options.map((item) => (
                <div
                  key={item._id}
                  onClick={() => handleSelect(item)}
                  onMouseEnter={() => setHoveredItem(item)}
                  onMouseLeave={() => setHoveredItem(null)}
                  className="flex gap-3 p-3 cursor-pointer hover:bg-gray-100 border-b border-white/50"
                >
                  <img
                    src={`${process.env.REACT_APP_BACKEND_URL}public/${item.image}`}
                    className="w-10 h-10 rounded object-cover"
                    alt={item.title}
                  />

                  <div className="flex-1">
                    <p className="font-mono text-16pt text-white">
                      {item.title}
                    </p>

                    {/* View more – Mobile & Tablet only */}
                    <button
                      onClick={(e) => {
                        e.stopPropagation(); // prevent parent click
                        setShowFood(true);
                        setShowingFoodItem(item);
                      }}
                      className="mt-1 text-sm text-orange font-mono text-right underline lg:hidden w-full"
                    >
                      View more
                    </button>
                  </div>
                </div>
              ))}

              {hoveredItem && (
                <div
                  className={`absolute hidden lg:flex flex-col top-0 ${
                    showOnLeft ? "right-full mr-4" : "left-full ml-4"
                  } w-80 bg-[#1f3d1a] text-white rounded-lg shadow-xl p-4 z-50`}
                >
                  <img
                    src={`${process.env.REACT_APP_BACKEND_URL}public/${hoveredItem.image}`}
                    className="w-full h-36 object-cover rounded mb-3"
                    alt={hoveredItem.title}
                  />

                  <h4 className="text-lg leading-none">{hoveredItem.title}</h4>

                  {hoveredItem.description && (
                    <div
                      className="text-sm mt-3 prose prose-invert max-w-none font-mono leading-tight"
                      dangerouslySetInnerHTML={{
                        __html: hoveredItem.description,
                      }}
                    />
                  )}

                  {hoveredItem.ingredients && (
                    <p className="text-sm font-mono mt-3">
                      Ingredients: {hoveredItem.ingredients}
                    </p>
                  )}

                  {hoveredItem.allergens?.length > 0 && (
                    <p className="text-sm mt-3 text-orange leading-tight">
                      Allergens: {hoveredItem.allergens.join(", ")}
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <Modal
        isOpen={showFood}
        onClose={() => setShowFood(false)}
        title={""}
        showConfirm={false}
        showCancel={false}
        customClass="md:max-w-[70%] max-h-[80%] overflow-scroll"
      >
        {showingFoodItem?.foodTime?.toLowerCase() != "lunch" && (
          <>
            <p className="text-34pt text-left leading-none mb-4">
              {showingFoodItem?.title}
            </p>

            <div className="group relative bg-white rounded-xl flex flex-col md:flex-row items-center md:items-start gap-4 text-left">
              {/* Left info */}
              <div className="flex-1 w-full">
                <div className="flex items-center flex-wrap gap-3 mb-3">
                  {showingFoodItem?.vegOrNonVeg && (
                    <span
                      className={`flex items-center gap-1 text-14pt px-3 py-1 rounded-full ${
                        showingFoodItem?.vegOrNonVeg === "Veg"
                          ? "bg-green/10 text-green"
                          : "bg-red-100 text-red-700"
                      }`}
                    >
                      <span
                        className={`w-2.5 h-2.5 me-1 rounded-full ${
                          showingFoodItem?.vegOrNonVeg === "Veg"
                            ? "bg-green/80"
                            : "bg-red-600"
                        }`}
                      ></span>
                      {showingFoodItem?.vegOrNonVeg}
                    </span>
                  )}

                  {showingFoodItem?.hotOrCold && (
                    <span
                      className={`text-14pt px-3 py-1 rounded-full ${
                        showingFoodItem?.hotOrCold === "Hot"
                          ? "bg-orange/20 text-orange"
                          : "bg-blue-100 text-blue-500"
                      }`}
                    >
                      {showingFoodItem?.hotOrCold}
                    </span>
                  )}

                  {showingFoodItem?.nutritionalInfo && (
                    <div className="flex flex-wrap gap-2">
                      {showingFoodItem?.nutritionalInfo
                        .split(",")
                        .map((nutri, idx) => (
                          <span
                            key={idx}
                            className="border border-quaternary text-quaternary text-14pt px-2 py-1 rounded-full"
                          >
                            {nutri.trim()}
                          </span>
                        ))}
                    </div>
                  )}
                </div>

                {/* Allergens */}
                {showingFoodItem?.allergens?.filter((a) => a.trim() !== "")
                  .length > 0 && (
                  <div className="w-fit bg-orange/10 border-l-4 border-orange p-2 mt-4 rounded-md shadow-sm flex items-center gap-2">
                    <motion.span
                      animate={{
                        rotate: [0, -10, 10, -10, 0],
                        scale: [1, 1.15, 1.05, 1.15, 1],
                      }}
                      transition={{
                        duration: 1.4,
                        repeat: Infinity,
                        ease: "easeInOut",
                      }}
                      className="text-orange text-xl"
                    >
                      ⚠️
                    </motion.span>

                    <p className="text-orange text-18pt font-sans">
                      Allergens:{" "}
                      {showingFoodItem?.allergens
                        .filter((a) => a.trim() !== "")
                        .join(", ")}
                    </p>
                  </div>
                )}

                {/* Description */}
                <div className="text-sm text-gray-700 mt-4 leading-relaxed  ">
                  {showingFoodItem?.ingredients && (
                    <p className="text-24pt font-mono flex items-center flex-wrap gap-0 ">
                      <FaBowlRice size={24} className="text-quaternary me-2" />
                      <span className="font-sans  leading-relaxed">
                        Ingredients:
                      </span>
                      <span className="leading-[35px] text-[22px] capitalize">
                        {showingFoodItem?.ingredients}
                      </span>
                    </p>
                  )}
                  {showingFoodItem?.description && (
                    <p
                      className="subtitle text-24pt abouthtml1 font-mono "
                      dangerouslySetInnerHTML={{
                        __html: cleanHTML(showingFoodItem?.description),
                      }}
                    />
                  )}
                </div>
              </div>

              {/* ------- Image Swiper ------- */}
              <div
                // title="Click to enlarge image"
                className="flex-shrink-0 w-[200px] h-[200px] cursor-pointer"
                // onClick={() => handleShowModal(mealItem)}
              >
                <Swiper
                  modules={[Pagination, Autoplay]}
                  pagination={{ clickable: true }}
                  autoHeight={true}
                  className="w-full h-full review small mb-4 md:mb-0"
                  onSlideChange={(s) => {
                    setActiveIndexMap((prev) => ({
                      ...prev,
                      [showingFoodItem?._id]: s.realIndex,
                    }));
                  }}
                >
                  {/* Main Image */}
                  {showingFoodItem?.image && (
                    <SwiperSlide
                      key="main"
                      className="cursor-pointer flex items-center justify-center bg-white aspect-[1/1] relative pb-10 hover:shadow-lg transition-shadow"
                    >
                      <img
                        src={`${process.env.REACT_APP_BACKEND_URL}public/${showingFoodItem?.image}`}
                        alt={showingFoodItem?.title}
                        onError={(e) => {
                          e.currentTarget.src = require("../../assets/images/link.png");
                          e.currentTarget.classList.add("object-contain");
                        }}
                        className="w-full h-[200px] object-contain bg-gray rounded-lg"
                      />
                    </SwiperSlide>
                  )}

                  {/* Extra Images */}
                  {Array.isArray(showingFoodItem?.pictures) &&
                    showingFoodItem?.pictures.slice(0, 2).map((img, i) => (
                      <SwiperSlide
                        key={i}
                        className="cursor-pointer flex items-center justify-center bg-white aspect-[1/1] relative pb-10"
                      >
                        <img
                          src={`${process.env.REACT_APP_BACKEND_URL}public/${img.image}`}
                          alt={showingFoodItem?.title}
                          onError={(e) => {
                            e.currentTarget.src = require("../../assets/images/link.png");
                            e.currentTarget.classList.add("object-contain");
                          }}
                          className="w-full h-[200px] object-contain bg-gray rounded-lg"
                        />
                      </SwiperSlide>
                    ))}
                </Swiper>
              </div>
            </div>
          </>
        )}
        {showingFoodItem?.foodTime?.toLowerCase() === "lunch" && (
          <>
            <div
              key={showingFoodItem?._id}
              className="group relative   bg-white rounded-xl  gap-4 text-left "
            >
              {/* Left info */}

              <div className="flex flex-col md:flex-row  lg:items-start justify-between gap-6">
                <div className="flex-1 w-full">
                  <p className="text-32pt mb-4 leading-tight">{showingFoodItem?.title}</p>
                  <div className="flex items-center flex-wrap gap-3 mb-3">
                    {showingFoodItem?.vegOrNonVeg && (
                      <span
                        className={`flex items-center gap-1 text-14pt px-3 py-1 rounded-full ${
                          showingFoodItem?.vegOrNonVeg === "Veg"
                            ? "bg-green/10 text-green"
                            : "bg-red-100 text-red-700"
                        }`}
                      >
                        <span
                          className={`w-2.5 h-2.5 me-1 rounded-full ${
                            showingFoodItem?.vegOrNonVeg === "Veg"
                              ? "bg-green/80"
                              : "bg-red-600"
                          }`}
                        ></span>
                        {showingFoodItem?.vegOrNonVeg}
                      </span>
                    )}

                    {showingFoodItem?.hotOrCold && (
                      <span
                        className={`text-14pt px-3 py-1 rounded-full ${
                          showingFoodItem?.hotOrCold === "Hot"
                            ? "bg-orange/20 text-orange"
                            : "bg-blue-100 text-blue-500"
                        }`}
                      >
                        {showingFoodItem?.hotOrCold}
                      </span>
                    )}

                    {showingFoodItem?.nutritionalInfo && (
                      <div className="flex flex-wrap gap-2">
                        {showingFoodItem?.nutritionalInfo
                          .split(",")
                          .map((nutri, idx) => (
                            <span
                              key={idx}
                              className="border border-quaternary text-quaternary text-14pt px-2 py-1 rounded-full"
                            >
                              {nutri.trim()}
                            </span>
                          ))}
                      </div>
                    )}
                  </div>

                  {/* Allergens */}
                  {showingFoodItem?.allergens?.filter((a) => a.trim() !== "")
                    .length > 0 && (
                    <div className="w-fit bg-orange/10 border-l-4 border-orange p-2 mt-4 rounded-md shadow-sm flex items-center gap-2">
                      <motion.span
                        animate={{
                          rotate: [0, -10, 10, -10, 0],
                          scale: [1, 1.15, 1.05, 1.15, 1],
                        }}
                        transition={{
                          duration: 1.4,
                          repeat: Infinity,
                          ease: "easeInOut",
                        }}
                        className="text-orange text-xl"
                      >
                        ⚠️
                      </motion.span>

                      <p className="text-orange text-18pt font-sans">
                        Allergens:{" "}
                        {showingFoodItem?.allergens
                          .filter((a) => a.trim() !== "")
                          .join(", ")}
                      </p>
                    </div>
                  )}

                  {/* Description */}
                </div>

                {/* ------- Image Swiper ------- */}
                <div
                  // title="Click to enlarge image"
                  className="flex-shrink-0 w-[200px] h-[200px] cursor-pointer"
                  // onClick={() => handleShowModal(showingFoodItem)}
                >
                  <Swiper
                    modules={[Pagination, Autoplay]}
                    pagination={{ clickable: true }}
                    autoHeight={true}
                    className="w-full h-full review small"
                    onSlideChange={(s) => {
                      setActiveIndexMap((prev) => ({
                        ...prev,
                        [showingFoodItem?._id]: s.realIndex,
                      }));
                    }}
                  >
                    {/* Main Image */}
                    {showingFoodItem?.image && (
                      <SwiperSlide
                        key="main"
                        className={`cursor-pointer flex items-center justify-center bg-white aspect-[1/1] relative  hover:shadow-lg transition-shadow ${
                          showingFoodItem?.pictures?.length > 0 ? "pb-10" : ""
                        }`}
                      >
                        <img
                          src={`${process.env.REACT_APP_BACKEND_URL}public/${showingFoodItem?.image}`}
                          alt={showingFoodItem?.title}
                          onError={(e) => {
                            e.currentTarget.src = require("../../assets/images/link.png");
                            e.currentTarget.classList.add("object-contain");
                          }}
                          className="w-full h-[200px] object-contain bg-gray rounded-lg"
                        />
                      </SwiperSlide>
                    )}

                    {/* Extra Images */}
                    {showingFoodItem?.pictures &&
                      Array.isArray(showingFoodItem?.pictures) &&
                      showingFoodItem?.pictures?.slice(0, 2).map((img, i) => (
                        <SwiperSlide
                          key={i}
                          className={`cursor-pointer flex items-center justify-center bg-white aspect-[1/1] relative ${
                            showingFoodItem?.pictures.length > 0 ? "pb-10" : ""
                          }`}
                        >
                          <img
                            src={`${process.env.REACT_APP_BACKEND_URL}public/${img.image}`}
                            alt={showingFoodItem?.title}
                            onError={(e) => {
                              e.currentTarget.src = require("../../assets/images/link.png");
                              e.currentTarget.classList.add("object-contain");
                            }}
                            className="w-full h-[200px] object-contain bg-gray rounded-lg"
                          />
                        </SwiperSlide>
                      ))}
                  </Swiper>
                </div>
              </div>

              <div
                className={`text-sm text-gray-700 leading-relaxed ${
                  showingFoodItem?.pictures?.length > 0 ? "mt-10 " : "mt-4  "
                }`}
              >
                {showingFoodItem?.description && (
                  <p
                    className={`subtitle text-24pt  font-mono ${"abouthtml1"}`}
                    dangerouslySetInnerHTML={{
                      __html: cleanHTML(showingFoodItem?.description),
                    }}
                  />
                )}
              </div>
            </div>
          </>
        )}
      </Modal>
    </>
  );
}

export default MealSelectionButton;
